import React from 'react';

const CariTakipPrivacy = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-16">
      <h1 className="text-4xl font-bold mb-6 text-center">Gizlilik Politikası</h1>
      <p className="text-center text-gray-600 mb-4">Son Güncelleme: Ekim 2025</p>
      <hr className="my-6" />

      <div className="max-w-3xl mx-auto space-y-6 text-justify leading-relaxed">
        <p>
          Cari Takip CRM uygulaması (“uygulama”), kullanıcılarının gizliliğine büyük önem verir. 
          Bu gizlilik politikası, uygulamanın hangi verileri topladığını, bu verileri nasıl kullandığını 
          ve nasıl koruduğunu açıklar.
        </p>

        <h2 className="text-xl font-semibold mt-8">1. Toplanan Veriler</h2>
        <p>
          Uygulama, kullanıcı deneyimini geliştirmek ve temel işlevleri sunmak amacıyla aşağıdaki bilgileri toplayabilir:
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li>E-posta adresi: Firebase Authentication aracılığıyla kayıt ve giriş işlemleri için.</li>
          <li>İşletme bilgileri: Kullanıcının kendi isteğiyle girdiği işletme adı, sektör, telefon numarası.</li>
          <li>Müşteri ve işlem verileri: Kullanıcının uygulama içindeki cari kayıtları (örneğin alacak, borç, tahsilat bilgileri).</li>
          <li>Teknik veriler: Uygulamanın düzgün çalışması için cihaz türü, sistem versiyonu gibi anonim teknik bilgiler.</li>
        </ul>
        <p>
          Uygulama hiçbir zaman konum, fotoğraf, kişi listesi veya mikrofon verisi toplamaz.
          Uygulamada herhangi bir reklam veya üçüncü taraf izleme SDK’sı bulunmaz.
        </p>

        <h2 className="text-xl font-semibold mt-8">2. Verilerin Kullanımı</h2>
        <p>
          Toplanan veriler yalnızca aşağıdaki amaçlarla kullanılır:
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li>Kullanıcı hesabının doğrulanması ve yönetilmesi</li>
          <li>Cari işlemlerin güvenli biçimde saklanması</li>
          <li>Uygulama performansının iyileştirilmesi</li>
          <li>Kullanıcının isteğiyle işletme bilgilerinin düzenlenmesi</li>
        </ul>
        <p>
          Veriler hiçbir koşulda üçüncü şahıslarla paylaşılmaz veya satılmaz.
        </p>

        <h2 className="text-xl font-semibold mt-8">3. Verilerin Saklanması ve Güvenliği</h2>
        <p>
          Tüm veriler Google Firebase altyapısında güvenli biçimde depolanır.
          Firebase, endüstri standartlarında güvenlik önlemleri (SSL, kimlik doğrulama, erişim kontrolü) uygular.
        </p>
        <p>
          Kullanıcı, hesabını istediği zaman silebilir veya verilerinin kaldırılması için geliştiriciyle iletişime geçebilir.
        </p>

        <h2 className="text-xl font-semibold mt-8">4. Ücretlendirme ve Değişiklik Hakkı</h2>
        <p>
          Uygulama şu anda tamamen ücretsiz olarak sunulmaktadır.
          Geliştirici, ilerleyen dönemlerde ek özellikler, abonelik sistemleri veya ücretli planlar sunma hakkını saklı tutar.
          Herhangi bir ücretlendirme değişikliğinde kullanıcılar önceden bilgilendirilecektir.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. İletişim</h2>
        <p>
          Herhangi bir soru, öneri veya veri silme talebi için bizimle iletişime geçebilirsiniz:
        </p>
        <p className="ml-4">
          E-posta: <a href="mailto:destek@caritakipcrm.com" className="text-blue-600">hi@n1inovasyon.com</a><br />
        </p>

        <h2 className="text-xl font-semibold mt-8">6. Değişiklikler</h2>
        <p>
          Bu gizlilik politikası zaman zaman güncellenebilir. 
          En güncel sürüm uygulama içinden veya web sitemizden görüntülenebilir.
        </p>
      </div>
    </div>
  );
};

export default CariTakipPrivacy;
